import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_TABLE_PAGE_SIZE } from 'AppConstants';

const userPageSlice = createSlice({
  name: 'userPage',
  initialState: {
    rows: [],
    totalElements: 0,
    page: 0,
    pageSize: DEFAULT_TABLE_PAGE_SIZE,
    sortBy: 'fullName',
    sortDirection: 'ASC',
    searchQuery: '',
    loading: false,
    initialized: false,
  },
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    replacePage(state, action) {
      const { rows, totalElements, page, pageSize } = action.payload;
      state.rows = rows;
      state.totalElements = totalElements;
      state.page = page;
      state.pageSize = pageSize;
      state.loading = false;
      state.initialized = true;
    },
    setPagination(state, action) {
      const { page, pageSize } = action.payload;
      if (typeof page === 'number') state.page = page;
      if (typeof pageSize === 'number') state.pageSize = pageSize;
    },
    setSort(state, action) {
      const { sortBy, sortDirection } = action.payload;
      if (sortBy) state.sortBy = sortBy;
      if (sortDirection) state.sortDirection = sortDirection;
      state.page = 0;
    },
    setSearchQuery(state, action) {
      state.searchQuery = action.payload ?? '';
      state.page = 0;
    },
    clear(state) {
      state.rows = [];
      state.totalElements = 0;
      state.searchQuery = '';
      state.loading = false;
    },
  },
});

export const userPageActions = userPageSlice.actions;
export default userPageSlice;
